import { Modifier, StrictModifierNames } from 'react-popper';

export const SUB_MENU_MOUSE_OUT_TIMEOUT = 50;
export const SUB_MENU_POPOVER_PLACEMENT = 'right-start';
export const SUB_MENU_POPOVER_MODIFIERS: Modifier<StrictModifierNames>[] = [
  {
    name: 'flip',
    enabled: true,
    options: {
      fallbackPlacements: ['left-start'],
    },
  },
  {
    name: 'offset',
    options: { offset: [-8, 0] },
  },
];
